export const colors = {
  // Background colors
  background: {
    dark: "#2D303F",
    input: "rgba(185, 192, 200, 0.50)",
    light: "rgb(255, 255, 255)",
  },

  // Border colors
  border: {
    top: {
      default: "rgba(255, 255, 255, 0.50)",
      hover: "rgb(105, 107, 212)",
      focused: "rgb(232, 232, 232)",
    },
  },
  button: {
    cancel: {
      background: "#E74C3C",
      hover: "#C0392B",
      focused: "#E74C3C",
      text: "#FFFFFF",
    },
    save: {
      background: "#2ECC71",
      hover: "#27AE60",
      focused: "#2ECC71",
      text: "#FFFFFF",
    },
  },

  // Text colors
  text: {
    label: {
      default: "rgba(216, 216, 216, 0.82)",
      focused: "rgb(255, 255, 255)",
    },
  },

  errorText: {
    400: "#eb606f",
    500: "#E74C3C",
    600: "#C0392B",
    700: "#A93226",
  },

  // Shadow colors
  shadow: {
    input: "rgba(0, 0, 0, 0.25)",
  },
} as const
